import type { Endpoint } from "../types";

interface EndpointListProps {
  endpoints: Endpoint[];
}

export function EndpointList({ endpoints }: EndpointListProps) {
  return (
    <div className="space-y-4">
      {endpoints.map((endpoint) => (
        <div
          key={endpoint.id}
          className="bg-white rounded-lg shadow p-4 flex items-center justify-between border border-gray-100"
        >
          <div className="flex items-center space-x-4">
            <div
              className={`w-3 h-3 rounded-full ${
                endpoint.status === "online"
                  ? "bg-green-500"
                  : endpoint.status === "offline"
                  ? "bg-red-500"
                  : "bg-yellow-500 animate-pulse"
              }`}
            />
            <div>
              <h3 className="font-medium">{endpoint.name}</h3>
              <p className="text-sm text-gray-500">{endpoint.sni}</p>
              {endpoint.error && (
                <p className="text-sm text-red-500 flex items-center mt-1">
                  {endpoint.error}
                </p>
              )}
              {endpoint.statusCode && (
                <p className="text-sm text-gray-500 mt-1">
                  Status: {endpoint.statusCode}
                </p>
              )}
            </div>
          </div>

          <div className="flex items-center space-x-4">
            {endpoint.latency !== null && (
              <span className="text-sm text-gray-600">
                {endpoint.latency}ms
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
